export default "__VITE_ASSET__DRldd9LW__"